module.exports = "/images/vendor/flag-icon-css/flags/1x1/is.svg?ae44c07e894b0a298c57b1380c5c11be";